import React, { useEffect, useRef } from 'react';
import { QRDesign } from '@/types/qr';
import { createQRStylingOptions } from '@/lib/qr/styling';
import { useDebouncedValue } from '@/hooks/useDebouncedValue';
import QRCodeStyling from 'qr-code-styling';

interface QRRendererProps {
  data: string;
  design: QRDesign;
  size?: number;
  className?: string;
}

export const QRRenderer: React.FC<QRRendererProps> = ({
  data,
  design,
  size = 280,
  className = ''
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const qrCodeRef = useRef<QRCodeStyling | null>(null);
  const debouncedData = useDebouncedValue(data, 180);
  const debouncedDesign = useDebouncedValue(design, 180);

  useEffect(() => {
    const options = createQRStylingOptions(debouncedData, debouncedDesign, size);

    if (!qrCodeRef.current) {
      qrCodeRef.current = new QRCodeStyling(options);
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
        qrCodeRef.current.append(containerRef.current);
      }
    } else {
      qrCodeRef.current.update(options);
    }
  }, [debouncedData, debouncedDesign, size]);

  return (
    <div
      ref={containerRef}
      className={`qr-canvas-container flex items-center justify-center transition-all ${className}`}
      style={{ width: size, height: size }}
    />
  );
};
